import React from 'react'

import poweredByTwGradient from '@frame/images/powered-by-tw-gradient.svg'
import poweredByTw from '@frame/images/powered-by-tw.svg'
import { DataAttribute } from '@frame/types'

export function PoweredByTruework({ gradient }: { gradient?: boolean }) {
  return (
    <img
      aria-label="Powered by Truework"
      role="img"
      data-cy={DataAttribute.POWERED_BY_TRUEWORK}
      src={gradient ? poweredByTwGradient : poweredByTw}
      className="mx-auto"
    />
  )
}
